import { RootState } from '@Store/index';
import { createSelector } from '@reduxjs/toolkit';

const auth = (state: RootState) => state.auth;

export const currentToken = createSelector(auth, ({ token }) => token);

export const currentTokenJSONKey = createSelector(
  auth,
  ({ jsonKey }) => jsonKey
);
